import { Label } from '@progress/kendo-react-labels'
import { StackLayout } from '@progress/kendo-react-layout'
import { DropDownList } from '@progress/kendo-react-dropdowns'

const himoku = ['型枠工', '鉄筋工', '鉄骨製作', '耐火被覆', '耐火巻付', 'PC躯体系', 'PCCW', 'ALC・ECP']

const building = ['マンション', '事務所', '学校', '工場･倉庫', '住宅', '病院', '商業施設', 'ホテル', '大学･専門学校', 'ﾃﾞｰﾀｾﾝﾀｰ', '研究実験施設', '庁舎', '美術館･博物館', '体育館']

const jyungyaku = ['順', '逆']

const kui = ['無', '有']

const menshin = ['無', '有']

const underStructure = ['-', 'RC', 'SRC', 'PC']

const structure = ['RC']

const kaisu = [
  '地下0Ｆ／地上1～2Ｆ',
  '地下0Ｆ／地上3～7Ｆ',
  '地下0Ｆ／地上8～15Ｆ',
  '地下0Ｆ／地上16～25Ｆ',
  '地下0Ｆ／地上26～35Ｆ',
  '地下0Ｆ／地上36～45Ｆ',
  '地下0Ｆ／地上46Ｆ～',
  '地下1Ｆ／地上1～2Ｆ',
  '地下1Ｆ／地上3～7Ｆ',
  '地下1Ｆ／地上8～15Ｆ',
  '地下1Ｆ／地上16～25Ｆ',
  '地下1Ｆ／地上26～35Ｆ',
  '地下1Ｆ／地上36～45Ｆ',
  '地下1Ｆ／地上46Ｆ～',
  '地下1Ｆ／地上1～2Ｆ',
  '地下1Ｆ／地上3～7Ｆ',
  '地下1Ｆ／地上8～15Ｆ',
  '地下1Ｆ／地上16～25Ｆ',
  '地下1Ｆ／地上26～35Ｆ',
  '地下1Ｆ／地上36～45Ｆ',
  '地下1Ｆ／地上46Ｆ～',
  '地下2Ｆ／地上1～2Ｆ',
  '地下2Ｆ／地上3～7Ｆ',
  '地下2Ｆ／地上8～15Ｆ',
  '地下2Ｆ／地上16～25Ｆ',
  '地下2Ｆ／地上26～35Ｆ',
  '地下2Ｆ／地上36～45Ｆ',
  '地下2Ｆ／地上46Ｆ～',
  '地下2Ｆ／地上1～2Ｆ',
  '地下2Ｆ／地上3～7Ｆ',
  '地下2Ｆ／地上8～15Ｆ',
  '地下2Ｆ／地上16～25Ｆ',
  '地下2Ｆ／地上26～35Ｆ',
  '地下2Ｆ／地上36～45Ｆ',
  '地下2Ｆ／地上46Ｆ～',
  '地下3Ｆ／地上1～2Ｆ',
  '地下3Ｆ／地上3～7Ｆ',
  '地下3Ｆ／地上8～15Ｆ',
  '地下3Ｆ／地上16～25Ｆ',
  '地下3Ｆ／地上26～35Ｆ',
  '地下3Ｆ／地上36～45Ｆ',
  '地下3Ｆ／地上46Ｆ～',
  '地下4Ｆ～／地上1～2Ｆ',
  '地下4Ｆ～／地上3～7Ｆ',
  '地下4Ｆ～／地上8～15Ｆ',
  '地下4Ｆ～／地上16～25Ｆ',
  '地下4Ｆ～／地上26～35Ｆ',
  '地下4Ｆ～／地上36～45Ｆ',
  '地下4Ｆ～／地上46Ｆ～',
  '地下4Ｆ～／地上1～2Ｆ',
  '地下4Ｆ～／地上3～7Ｆ',
  '地下4Ｆ～／地上8～15Ｆ',
  '地下4Ｆ～／地上16～25Ｆ',
  '地下4Ｆ～／地上26～35Ｆ',
  '地下4Ｆ～／地上36～45Ｆ',
  '地下4Ｆ～／地上46Ｆ～'
]

export default function ConstPeriodSettingSearchCondition() {
  return (
    <>
      <h3>検索条件</h3>

      <StackLayout gap={5} orientation="vertical">
        <Label>費目</Label>
        <DropDownList data={himoku} defaultValue={'型枠工'} />

        <Label>建物用途</Label>
        <DropDownList data={building} defaultValue={'マンション'} />

        <Label>階数</Label>
        <DropDownList data={kaisu} defaultValue={'地下0Ｆ／地上1～2Ｆ'} />

        <Label>基礎構造</Label>
        <DropDownList data={structure} defaultValue={'RC'} />

        <Label>地下構造</Label>
        <DropDownList data={underStructure} defaultValue={'-'} />

        <h4>工法</h4>
        <Label>順・逆</Label>
        <DropDownList data={jyungyaku} defaultValue={'順'} />

        <Label>杭</Label>
        <DropDownList data={kui} defaultValue={'有'} />

        <Label>免震</Label>
        <DropDownList data={menshin} defaultValue={'無'} />
      </StackLayout>
    </>
  )
}
